import { React, useEffect, useState, useContext } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from "../../../App";
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import messages from '../../../assets/Messages.json'
import {generateSurveyYears, validateRolesASI} from '../../../Custom/Custom';
import asiInputTitle from '../../../titles.json';
import axios from "axios";
import { API_URL } from "../../../Constant";

export default function AsiDataUpload() {

  const [years, setYears] = useState([]);
  const [yearName, setYearName] = useState("");
  const [fileType, setFileType] = useState("");
  const storedLanguage = localStorage.getItem('language');
  const [file, setFile] = useState(null);
  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const decodedToken = jwtDecode(token);
        const isAuthorized = await validateRolesASI(decodedToken);

        if (!isAuthorized) {
          window.alert("You are not an authorized user to capture the data for ASI Data Upload");
          navigate("/dashboard");
          return;
        }
      } catch (error) {
        console.error('Error checking authorization:', error);
      }
    };

    checkAuthorization();
  }, [token, navigate]);

// Handle on change Event ********
const handleDropdownChange = (e) => {
    
  switch (e.target.name) {
      case "yearName":
      setYearName(e.target.value);
      break;
      case "fileType":
      setFileType(e.target.value);
      break;
  default:
      console.log("switch case are not match");
      break;
  }
};


const handleFileChange = (e) => {
  const selectedFile = e.target.files[0];

   if (selectedFile) {
      //  if (selectedFile.size > 40 * 1024 * 1024) {
      //       toast.error(messages.SIZE_40_MB, messages.COLOR_RED);
      //       setFile(null);
      //       return;
      // }

       const fileNameParts = selectedFile.name.split('.');
       const fileExtension = fileNameParts[fileNameParts.length - 1].toLowerCase();
      
      if (fileExtension !== 'txt') {
          toast.error("Please Upload text file", messages.COLOR_RED);
          setFile(selectedFile);
           return;
      }

      setFile(selectedFile);
  }
};


const submitFormData= async ()=>{

  if (yearName==='') {
    toast.error('Please select year', messages.COLOR_RED);
    return;
  }
      
 if(fileType===''){
    toast.error("Please Select file type", messages.COLOR_RED);
    return;
  }

  if(file===null){
    toast.error("Please select file to upload.", messages.COLOR_RED);
    return;
  }

  const fileNameParts = file.name.split('.');
  const fileExtension = fileNameParts[fileNameParts.length - 1].toLowerCase();
 
 if (fileExtension !== 'txt') {
     toast.error("Please Upload text file", messages.COLOR_RED);
     return;
 }

    showLoading(true)
    const formData = new FormData();
      
  let post_data={
    fileType:fileType,
    survey_year:yearName,
  }
  
    const newObjectString = JSON.stringify(post_data);
    formData.append('file', file);
    formData.append('asifileinfo', newObjectString);
    try {
      const response = await axios.post(`${API_URL}api/asi/uploadfileData`, formData, config);
      const res=response.data;
     
      if(res.status){
        toast.success(res.message, messages.COLOR_RED);
        formData.append('file','');
        setYearName('');
        setFileType('');
        setFile(null);
        showLoading(false)
        const fileInput = document.getElementById('fileInput');
          if (fileInput) {
              fileInput.value = '';
          }
    }else{
      toast.error('File is not Uploaded', messages.COLOR_RED);
    }
      
    } catch (error) {
      console.error('Error posting data:', error);
    }finally{
      showLoading(false);
    }



}


  return (
    <>
    <GlobalLoading />
    <ToastContainer />
    <div className="container-fluid py-3">
      <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="row align-items-center">
         

            <div className="row align-items-center">

          <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                 <label className="fw-bold h6">
                 {storedLanguage === 'hi' ? asiInputTitle.hi.SURVEY_YAER : asiInputTitle.en.SURVEY_YAER}
                  </label>
                  <select
                  name="yearName"
                  className="form-select"
                  onChange={handleDropdownChange}
                  value={yearName}
                 >
                  <option value="" disabled>
                    Select Year
                  </option>
                    {generateSurveyYears().map((year, index) => (
                      <option key={index} value={year.split('-')[0]}>
                        {year}
                     </option>
                    ))}
                </select>
                 </div>


                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                     <label>File Type </label>
                     <select
                      name="fileType"
                      className="form-select"
                      onChange={handleDropdownChange} 
                      value={fileType}
                     >
                   <option value="" disabled>[--Select--]</option>
                       <option  value="1"> Central </option>
                       <option  value="2"> State </option>
                  </select>
                 </div>

                 
                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                 <label>Please upload a file (.txt)</label>
                 <input 
                  type="file" 
                  className="form-control" 
                  onChange={handleFileChange}  
                  id="fileInput"
                  accept=".txt"

                 />
                    
                 </div>

                 <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label className="w-100">&nbsp;</label>
                    <button type="button" 
                    className="btn btn_orange" 
                    onClick={submitFormData} 
                    >
                      Submit
                  </button>
                   </div>



              
            </div>
          </div>
        </div>
      </div>

    </div>
   </>
  )
}
